import FaqPageItems from "../../../../src/components/faqPageItems";
import * as React from 'react';
export default {
  FaqPageItems,
  React
};